import * as React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Reveal — fades & slides its children into view on scroll.
 * Respects prefers-reduced-motion.
 */
export default function Reveal({
  children,
  delay = 0,
  y = 28,
  x = 0,
  duration = 0.6,
  once = true,
  amount = 0.25,
  style,
  ...rest
}) {
  const reduce = useReducedMotion();

  if (reduce) {
    return (
      <div style={style} {...rest}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y, x }}
      whileInView={{ opacity: 1, y: 0, x: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      style={style}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

/**
 * Stagger — container that reveals children one after another.
 */
export function Stagger({ children, gap = 0.09, style, ...rest }) {
  const reduce = useReducedMotion();

  if (reduce) {
    return (
      <div style={style} {...rest}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      variants={{
        hidden: {},
        show: { transition: { staggerChildren: gap } },
      }}
      style={style}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export const staggerItem = {
  hidden: { opacity: 0, y: 26 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
};

export const MotionDiv = motion.div;
